module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "swipe-wrap"
  }, [_c('mt-swipe', {
    attrs: {
      "auto": 2000
    }
  }, [_c('mt-swipe-item', [_c('img', {
    attrs: {
      "src": require(".././assets/banner.png")
    }
  })]), _c('mt-swipe-item', [_c('img', {
    attrs: {
      "src": require(".././assets/banner.png")
    }
  })]), _c('mt-swipe-item', [_c('img', {
    attrs: {
      "src": require(".././assets/banner.png")
    }
  })])], 1)], 1), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": "/newfood"
    }
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/longxia.png")
    }
  }), _c('div', {
    staticClass: "mask"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/x-longxia.png")
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("新品推荐")])])])], 1), _vm._m(0), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/koubei.png")
    }
  }), _c('div', {
    staticClass: "mask"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/x-pangxie.png")
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("口碑好菜")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/discount.png")
    }
  }), _c('div', {
    staticClass: "mask"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/x-fish.png")
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("限时优惠")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47235fe6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 115
// module chunks = 0